module.exports = __webpack_public_path__ + "static/media/cornell.b1a6521d.png";